/**
 * Generate the Url of booking for track from mobile website
 * Pattern is https://mobile-domain/b/BookingId/AccessCode
 * 
 * The caller will decide whether the "AccessCode" is "read only" or "read + write".
 */
export function GenerateBookingTrackingUrl(bookingId: string, accessCode: string, baseUrl: string): string {
    return baseUrl + bookingId + "/" + accessCode;
}
